import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import interactionResponse from 'await-interaction-response';
import _isEqual from 'lodash/isEqual';

import { Button, Glyphicon } from 'reaxl';

import activeInteractionDuck from '@/ducks/activeInteractionDuck.js';
import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import { useSuggestedSearches } from '@/hooks/useSuggestedSearches';

function MobileSearchFilterButtons({ showSearchButton = true }) {
    const dispatch = useDispatch();

    const filters = useSelector(srpFiltersDuck.selectors.getSelectedFilterChips, _isEqual);
    const filterCount = filters.length;

    const { loadSuggestions = () => {} } = useSuggestedSearches();
    const handleShowKeywordModal = () => {
        dispatch(activeInteractionDuck.creators.setKeys({
            showKeywordSearchModal: true,
        }));
        loadSuggestions();
    };

    const handleFilterClick = useCallback(async () => {
        await interactionResponse();
        dispatch(srpFiltersDuck.creators.showFilters());
    }, [dispatch]);

    return (
        <>
            {showSearchButton && (
                <Button
                    className="display-flex text-gray-base margin-3 text-nowrap"
                    bsStyle="text"
                    onClick={handleShowKeywordModal}
                >
                    <Glyphicon
                        glyph="ai-search"
                        className="text-accent text-size-500"
                        key="ai-search-glyph"
                    />
                </Button>
            )}
            <span className="text-subdued-light text-size-500">|</span>
            <Button
                key="mobileFilterButton"
                onClick={handleFilterClick}
                data-cmp="mobileFilterButton"
                bsStyle="text"
                className="display-flex text-gray-base margin-3 text-nowrap"
            >
                <Glyphicon
                    glyph="filter"
                    className="margin-right-2 text-accent text-size-500"
                    key="filter-glyph"
                />
                Filters
                {' '}
                {filterCount > 0 && `(${filterCount})`}
            </Button>
        </>
    );
}

MobileSearchFilterButtons.propTypes = {
    showSearchButton: PropTypes.bool,
};

MobileSearchFilterButtons.defaultProps = {
    showSearchButton: true,
};

export default MobileSearchFilterButtons;
